import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";
import moderate from "../../../../Assests/SVG/moderate.svg";
import clean from "../../../../Assests/SVG/clean.svg";
import critical from "../../../../Assests/SVG/critical.svg";
import { GetSectorSeverity } from "../../../../ApiServices/ApiRequests";
import { useCtmLiveOverView } from "../../../../ContextAPI/CtmLiveOverViewContext";

interface WasteStatusProps {
  cleanCount: number;
  moderateCount: number;
  criticalCount: number;
}

const SeverityCard = () => {
  const { t } = useTranslation();

  const { ctmLiveOverViewState, dispatchCtmLiveOverView } =
    useCtmLiveOverView();

  // const [severityPercent, setSeverityPercent] = useState<WasteStatusProps>(
  //   {} as WasteStatusProps
  // );

  // useEffect(() => {
  //   retrieveData();
  // }, []);

  // const retrieveData = async () => {
  //   try {
  //     const result = await GetSectorSeverity();
  //     // Assuming the data is in result.data.data
  //     setSeverityPercent({
  //       criticalCount: result.criticalPercentage,
  //       moderateCount: result.moderatePercentage,
  //       cleanCount: result.cleanPercentage,
  //     });
  //   } catch (e) {
  //     console.error("Error fetching  routes severity Count data:", e);
  //   }
  // };

  return (
    <Card variant="outlined" sx={{ p: 2, mb: 2, width: "100%" }}>
      <Grid2 container spacing={2}>
        {/* Clean */}
        <Grid2 size={{ xs: 4 }}>
          <Box display="flex" alignItems="center">
            <img
              src={clean}
              alt="Clean Bin Icon"
              style={{
                width: "25px",
                height: "25px",
                marginRight: "8px",
              }}
            />
            <Typography variant="h5">
              {t("global.Clean")}:{" "}
              {ctmLiveOverViewState.SeverityPercent?.clean
                ? `${ctmLiveOverViewState.SeverityPercent?.clean}%`
                : 0}
            </Typography>
          </Box>
        </Grid2>

        {/* Moderate */}
        <Grid2 size={{ xs: 4 }}>
          <Box display="flex" alignItems="center">
            <img
              src={moderate}
              alt="Moderate Bin Icon"
              style={{
                width: "25px",
                height: "25px",
                marginRight: "8px",
              }}
            />
            <Typography variant="h5">
              {t("global.Moderate")}:{" "}
              {ctmLiveOverViewState.SeverityPercent?.moderate
                ? `${ctmLiveOverViewState.SeverityPercent?.moderate}%`
                : 0}
            </Typography>
          </Box>
        </Grid2>

        {/* Critical */}
        <Grid2 size={{ xs: 4 }}>
          <Box display="flex" alignItems="center">
            <img
              src={critical}
              alt="Critical Bin Icon"
              style={{
                width: "25px",
                height: "25px",
                marginRight: "8px",
              }}
            />
            <Typography variant="h5">
              {t("global.Critical")}:{" "}
              {ctmLiveOverViewState.SeverityPercent?.critical
                ? `${ctmLiveOverViewState.SeverityPercent?.critical}%`
                : 0}
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default SeverityCard;
